import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 29.5,
			stroke: "#005AA0",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.675 22.775H35.075C35.6411 22.775 36.1 23.234 36.1 23.8V30.3112V33.6889V40.2001C36.1 40.7661 35.6411 41.225 35.075 41.225H18.675C18.1089 41.225 17.65 40.7661 17.65 40.2V23.8C17.65 23.234 18.1089 22.775 18.675 22.775ZM40.2 37.2349V40.2001C40.2 43.0305 37.9054 45.325 35.075 45.325H18.675C15.8445 45.325 13.55 43.0305 13.55 40.2V23.8C13.55 20.9696 15.8445 18.675 18.675 18.675H35.075C37.9055 18.675 40.2 20.9696 40.2 23.8V26.7652L48.9556 22.4656C50.5902 21.6629 52.5 22.8527 52.5 24.6737V39.3264C52.5 41.1474 50.5902 42.3372 48.9556 41.5345L40.2 37.2349ZM40.2 32.6672L48.4 36.694V27.3061L40.2 31.3329V32.6672Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgVideoCircle);
export { ForwardRef as ReactComponent };
